module.exports = __webpack_public_path__ + "img/tctReagent.97996c66.png";